import axios from 'axios';

axios.defaults.baseURL = 'https://fondue.traffy.in.th';



// WEBPACK FOOTER //
// ./src/components/Util/Client.js